import {connect} from "react-redux";
import './ImagesStats.scss';

function ImagesStats(props) {
	const sizes = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb']
	const formatStats = bytes => {
		let val = parseFloat(bytes);
		for(let i = 0; i < sizes.length; i++) {
			if (val < 100) {
				return val.toFixed(2).toString() + ' ' + sizes[i];
			}
			val = val / 1024;
		}
		return val.toFixed(2).toString() + ' ' + sizes[sizes.length - 1];
	}

	return (<div className={"imagesStats-container"}>
		Used: {props.imagesStats && props.imagesStats.imagessize ? formatStats(props.imagesStats.imagessize) : '0'}
	</div>)
}

const mapStateToProps = state => {
	return {
		imagesStats: state.eventsData.imagesStats
	};
};

export default connect(mapStateToProps)(ImagesStats);